module.exports = __webpack_public_path__ + "static/scale-model-of-horse-country-in-lexington-kentucky-17251fe0ef4f9720b2da83b8e04cfe3d.png";